export { default as Img200 } from './processed/200/osbornebulls.jpg';
export { default as Img400 } from './processed/400/osbornebulls.jpg';
export { default as Imgthumb } from './processed/thumb/osbornebulls.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/osbornebulls.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/osbornebulls.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      53,
      147,
      243
    ],
    "_population": 10,
    "_hsl": [
      0.5842105263157895,
      0.8878504672897195,
      0.580392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      188,
      212,
      252
    ],
    "_population": 1093,
    "_hsl": [
      0.6041666666666666,
      0.9142857142857146,
      0.8627450980392157
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      84,
      27,
      14
    ],
    "_population": 1022,
    "_hsl": [
      0.03095238095238095,
      0.7142857142857144,
      0.19215686274509802
    ]
  },
  "Muted": {
    "_rgb": [
      96,
      86,
      168
    ],
    "_population": 54,
    "_hsl": [
      0.6869918699186992,
      0.3228346456692913,
      0.4980392156862745
    ]
  },
  "LightMuted": {
    "_rgb": [
      187,
      190,
      204
    ],
    "_population": 25,
    "_hsl": [
      0.6372549019607842,
      0.14285714285714307,
      0.7666666666666666
    ]
  },
  "DarkMuted": {
    "_rgb": [
      80,
      55,
      60
    ],
    "_population": 64,
    "_hsl": [
      0.9666666666666667,
      0.18518518518518515,
      0.2647058823529412
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/osbornebulls.js